import React from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames';
import '@/companys/ttl/assets/styles/components/detail-center/news.scss';

import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE, NEWS_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY } from '@/constants/app';
import { utilsFunction, Converter,keyDownFunctions,accessibilityFunctions } from "@/helpers/functions";
import moment from 'moment';
import { settingConfigs } from '@/configurations';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';

import { openNewsDetailDialog } from '@/actions/app/dialog.action'
import NoRow from '@/components/DataTable/CustomNoRow';
class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newData: [],
      load: false
    }
  }

  componentDidMount() {
    this.props.innerRef(this)
    this.getNewsData()
  }

  componentDidUpdate(prevProps, prevState) {
    const { marketParams } = this.props;
    const { marketID, stockCode } = marketParams;
    // if(Number(10000)<=Number(stockCode) && Number(stockCode)<=20000 && marketID ==='HKEX' || !stockCode) return;
    if (marketParams && marketParams !== prevProps.marketParams) {
      if (utilsFunction.instrumentIDZeroPadding(stockCode) !== utilsFunction.instrumentIDZeroPadding(prevProps.marketParams.stockCode )) {
        this.getNewsData()
      }
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  getNewsData() {
    
    const { language, marketParams } = this.props;
    let marketID = null
    let stockCode = null
    if(this.props.marketParams.stockCode < 10000 || this.props.marketParams.stockCode > 29999){
        marketID = this.props.marketParams.marketID
        stockCode = this.props.marketParams.stockCode
    }else {
      if(!this.props.NCmarketParams.NCmarketID || !this.props.NCmarketParams.NCstockCode) return
        marketID = this.props.NCmarketParams.NCmarketID
        stockCode = this.props.NCmarketParams.NCstockCode
    }
    if (!(marketID && stockCode)){
      this.setState({
        newData: []
      })
      return
    } 
    this.setState({
      load: true,
      newData: []
    })

    const params = {
      subscribe: null,
      msgType: ACTION_TYPE.NEWS,
      category: NEWS_TYPE.MAIN_NEWS,
      datetime: moment().format(settingConfigs.LONG_DATE),
      count: 20,
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketID),
          key: stockCode === 'USEX' ? stockCode : Converter.mappingStockCode(stockCode)
        }
      ],
      language: language.lang !== 'zh_CN' ? utilsFunction.switchToolTipsLanguage(language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC) : WS_LANG_KEY.TC
    }
    this.props.getNews(params, res => {
      this.setState({ load: false })
      if (res.rtnCode) return
      let data = this.state.newData;
      if (data.length == 0) {
        data.push(res)
      } else {
        if (data.findIndex(item => item.id == res.id) == -1) {
          data.push(res)
        }
      }
      this.setState({
        newData: data
      })
    })
  }

  render() {
    const { language, isMobile } = this.props;
    const { newData, load } = this.state;
    return (
      <React.Fragment>
        <div className={classnames('news-container-ttl', isMobile && 'news-mobile-container')}>
          <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
          {
            !load && Array.isArray(newData) && newData.length == 0 && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }} />
          }
          <section>
            {newData.map((news, index) =>
              <div onClick={() => openNewsDetailDialog(newData, news.id)} key={news.id + index} className="item"
                   onKeyDown={keyDownFunctions.handleEnterKeyDown(() => openNewsDetailDialog(newData, news.id))}
                   {...accessibilityFunctions.hasTabIndex()}>
                <span className="stock-code">[ {news.source} ]</span>
                <span className="title">{news.headline}</span>
                <span className="time">{moment(news.releaseTime).format(settingConfigs.LONG_DATE)}</span>
              </div>
            )}
          </section>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    marketParams: state.trade.marketParams,
    NCmarketParams:state.trade.NCmarketParams,
  }),
  dispatch => ({
    getNews: (p, c) => stockActions.getNewsAction(p, c)
  })
)(News)